import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./contexts/CartContext";
import { InstallAppProvider } from "./hooks/useInstallApp";
import { InstallGuideModal } from "./components/InstallApp";
import Home from "./pages/Home";

// Register the IPFS media service worker so product thumbnails/videos are
// served instantly from cache after the first visit.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL || ""}/sw.js`)
            .catch((err) => console.warn("[sw] registration failed:", err));
    });
}

function App() {
    return (
        <div className="App">
            <InstallAppProvider>
                <CartProvider>
                    <HashRouter>
                        <Routes>
                            <Route path="/" element={<Home />} />
                        </Routes>
                    </HashRouter>
                    <Toaster position="top-right" richColors />
                    <InstallGuideModal />
                </CartProvider>
            </InstallAppProvider>
        </div>
    );
}

export default App;
